<template>
    <div class="section section_portfolio" v-if="item">
        <h2 class="section__title grey--text" data-aos="fade-up">{{ item.title }}</h2>
        <div class="portfolio" v-for="image in item.images">
            <img class="portfolio__img" data-aos="fade-up" :src="$apiHost + image.src" alt="portfolio_aks1">
        </div>
        <button class="link_more black--text" @click="$router.go(-1)">
            <img src="@/assets/svg/arrow.svg"><span> {{back}}</span>
        </button>
    </div>
</template>

<script>
    export default {
        props: ['id'],
        computed: {
            back() {
                if (!this.$route.params.lang) {
                    return 'назад'
                } else if (this.$route.params.lang === 'fr') {
                    return 'retour'
                } else {
                    return 'back'
                }
            },
            item() {
                if (this.resources !== null) {
                  for(let i = 0; i < this.resources.portfolio.items.length; i++) {
                    if (this.resources.portfolio.items[i].slug === this.id)
                      return this.resources.portfolio.items[i]
                  }
                }
            },
            resources() {
                return this.$store.state.resources
            },
        }
    }
</script>

<style lang="scss" scoped>

    .section_portfolio {
        height: auto;
        top: 100px;
        background: linear-gradient(#fdfdfd, #e6e6e6);
    }

    .portfolio {
        margin-top: 73px;
        z-index: 9;
        padding-left: 35%;
        display: block;
        position: relative;
        font-family: 'CirceRegular', sans-serif;
        width: 100%;
        @media screen and (max-width: 800px) {
            margin-right: 0;
            margin-left: 0;
            padding: 0;
        }
    }

    .portfolio:nth-child(odd) {
        padding-left: 0;
        padding-right: 35%;
        margin-right: auto;
        margin-left: 10%;
        @media screen and (max-width: 800px) {
            margin-right: 0;
            margin-left: 0;
            padding: 0;
        }
    }

    .portfolio__img {
        width: 100%;
    }

    .portfolio:nth-child(2):after {
        position: absolute;
        content: '';
        width: 60%;
        height: 150%;
        left: -10%;
        top: 30%;
        z-index: -1;
        background: url('../assets/img/MA_1920_beton2.png');
        background-position: right;
        background-repeat: no-repeat;

    }

    .portfolio:nth-child(3):after {
        position: absolute;
        content: '';
        width: 50%;
        height: 130%;
        top: 40%;
        right: 0;
        z-index: -2;
        background: url('../assets/img/MA_1920_beton3.png');
        background-position: left;
        background-repeat: no-repeat;

    }

    .link_more {
        position: fixed;
        height: 100px;
        font-weight: 600;
        font-family: 'CirceRegular', sans-serif;
        top: 0;
        z-index: 101;
        right: 0;
        width: 100%;
        display: flex;
        font-size: 18px;
        color: #a4a5a4;
        background-color: #fdfdfd;
        text-decoration: none;
        transition: .2s;
        margin: 0;
        padding-right: 10%;
        border: none;
        box-shadow: none;
        justify-content: flex-end;
        align-items: center;
        outline: none;
    }

    .link_more img {
        width: 120px;
        transform: rotate(180deg);
        margin-right: 40px;


    }

    .link_more span {
        display: block;
    }

    .link_more:hover {
        opacity: 1;
    }

</style>



// WEBPACK FOOTER //
// src/components/CaseBlock.vue